import { useTranslation } from "react-i18next";
import { FaLinkedinIn } from "react-icons/fa";
import React from "react";


const Footer = () => {
  const { t } = useTranslation();
    const SocialShare = [
        {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/company/kensei-group'},
    ]
  
  return (
      <div className="footer-style-2 ptb--30 bg_image bg_image--1" data-black-overlay="6">
          <div className="wrapper plr--50 plr_sm--20">
              <div className="row align-items-center justify-content-between">
                  <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="inner">
                          <div className="text-center text-sm-left mb_sm--20">
                          {/*    тут можно сделать лого в футере */}
                              <img className="logo" src="/assets/images/logo/logo.svg" alt="Logo Image"/>
                          </div>
                      </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="inner text-center">
                          <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
                              {SocialShare.map((val , i) => (
                                  <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                              ))}
                          </ul>
                      </div>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                      <div className="inner text-lg-right text-center mt_md--20 mt_sm--20">
                          <div className="text">
                              <p>{t('footer.rights')}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  );
}

export default Footer;
